export const pendingUsersApiPageSelector = (state, page) => {
  return state.api.pendingUsers.pages[page];
};

export const pendingUsersApiSelector = ({ state }) => state.api.pendingUsers;
